import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/common/Marquee";
import { TrustBar } from "@/components/home/TrustBar";
import { Manifesto } from "@/components/home/Manifesto";
import { MeetDoctor } from "@/components/home/MeetDoctor";
import { TreatmentsBento } from "@/components/home/TreatmentsBento";
import { AestheticHighlight } from "@/components/home/AestheticHighlight";
import { ProblemsGrid } from "@/components/home/ProblemsGrid";
import { ClinicShowcase } from "@/components/home/ClinicShowcase";
import { BeforeAfterGallery } from "@/components/common/BeforeAfterGallery";
import { GoogleReviewsWidget } from "@/components/common/GoogleReviewsWidget";
import { AreasServed } from "@/components/home/AreasServed";
import { FaqSection } from "@/components/home/FaqSection";
import { CtaBand } from "@/components/common/CtaBand";
import { MapSection } from "@/components/home/MapSection";
import { Seo } from "@/components/common/Seo";
import { buildLocalBusinessSchema, buildFaqSchema } from "@/lib/schema";
import { FAQS } from "@/data/site";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Dr. Ankesh Seth — Dentist in Varanasi | Best Dental Clinic in Paharia"
        description="Dr. Ankesh Seth is a leading dentist in Varanasi offering dental implants, root canal treatment and smile makeovers — plus advanced skin & hair treatments like HydraFacial, Botox, PRP and hair transplant — at his Paharia clinic. Book online, call or WhatsApp today."
        path="/"
        jsonLd={[buildLocalBusinessSchema(), buildFaqSchema(FAQS)]}
      />
      <Hero />
      <TrustBar />
      <Marquee text="Precision dentistry for Varanasi — Dr. Ankesh Seth — Excellence in Care" />
      <Manifesto />
      <MeetDoctor />
      <TreatmentsBento />
      <AestheticHighlight />
      <ProblemsGrid />
      <ClinicShowcase />
      <BeforeAfterGallery />
      <GoogleReviewsWidget muted />
      <AreasServed />
      <FaqSection muted />
      <CtaBand />
      <MapSection />
    </div>
  );
}
